module.exports = __webpack_public_path__ + "static/media/mortgage_white.e4ef49aa.svg";